import { createStyle } from '@gluestack-style/react';
export const RadioIcon = createStyle({
    borderRadius: '$full',
    ':checked': {
        color: '$white',
        ':hover': {
            color: '$gray100',
            ':disabled': {
                color: '$gray300',
            },
        },
    },
    _dark: {
        ':checked': {
            color: '$primary500',
            ':disabled': {
                color: '$primary500',
            },
            ':hover': {
                ':disabled': {
                    color: '$primary500',
                },
                color: '$primary400',
            },
        },
    },
});
